import React, { useState } from 'react';

type PlayerNameModalProps = {
  onSubmit: (name: string) => void;
};

const PlayerNameModal: React.FC<PlayerNameModalProps> = ({ onSubmit }) => {
  const [name, setName] = useState('');  return (
    <div id="playerNameModal" className="modal-overlay">
      <div className="modal-content name-modal">
        <h2 className="modal-title">Welcome, Commander!</h2>
        <label htmlFor="playerNameInput" className="modal-label">Enter your name:</label>
        <input 
          id="playerNameInput" 
          type="text" 
          maxLength={32} 
          className="text-input" 
          autoFocus 
          value={name} 
          onChange={e => setName(e.target.value)} 
          onKeyDown={e => { if (e.key === 'Enter') onSubmit(name.trim() || 'Player'); }} 
        />
        <button 
          className="button button-primary full-width" 
          onClick={() => onSubmit(name.trim() || 'Player')}
        >
          Start
        </button>
      </div>
    </div>
  );
};

export default PlayerNameModal;
